var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 35.1562C29.3147 35.1562 32.8125 31.6585 32.8125 27.3438C32.8125 23.029 29.3147 19.5312 25 19.5312C20.6853 19.5312 17.1875 23.029 17.1875 27.3438C17.1875 31.6585 20.6853 35.1562 25 35.1562Z",
    stroke: "#C7858B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 22.6563C40.1007 22.6547 41.8955 23.0776 43.523 23.8911C45.1504 24.7047 46.5658 25.8866 47.6565 27.3429",
    stroke: "#C7858B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 27.3433C3.43446 25.8869 4.8498 24.7049 6.47733 23.8913C8.10486 23.0776 9.89972 22.6547 11.7193 22.6563",
    stroke: "#C7858B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7559 42.1873C14.7823 40.0791 16.3807 38.302 18.3688 37.0587C20.3568 35.8155 22.6543 35.1563 24.9991 35.1563C27.3439 35.1562 29.6414 35.8155 31.6295 37.0587C33.6175 38.3019 35.216 40.0791 36.2424 42.1873",
    stroke: "#C7858B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7195 22.6563C10.5337 22.656 9.37235 22.3184 8.37117 21.6829C7.36998 21.0474 6.57027 20.1401 6.06541 19.0671C5.56054 17.9941 5.37137 16.7996 5.51998 15.623C5.66858 14.4465 6.14883 13.3366 6.90465 12.4228C7.66047 11.509 8.66066 10.8291 9.78842 10.4624C10.9162 10.0958 12.125 10.0576 13.2737 10.3523C14.4223 10.6469 15.4635 11.2623 16.2755 12.1265C17.0875 12.9907 17.6369 14.0681 17.8596 15.2329",
    stroke: "#C7858B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1406 15.2331C32.3631 14.0681 32.9125 12.9905 33.7246 12.1261C34.5366 11.2617 35.5779 10.6462 36.7267 10.3514C37.8755 10.0566 39.0845 10.0948 40.2124 10.4614C41.3403 10.8281 42.3407 11.508 43.0966 12.4219C43.8525 13.3358 44.3328 14.446 44.4814 15.6226C44.63 16.7993 44.4408 17.994 43.9358 19.0671C43.4308 20.1403 42.6309 21.0476 41.6296 21.6831C40.6282 22.3187 39.4667 22.6562 38.2807 22.6563",
    stroke: "#C7858B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersNew);
export default __webpack_public_path__ + "static/media/UsersNew.bf3efa2764f045e20b2769033d073215.svg";
export { ForwardRef as ReactComponent };